// extracted by mini-css-extract-plugin
module.exports = {"center":"Answers_center__SDtjn","card":"Answers_card__2Kqfm","rankings":"Answers_rankings__3XkFJ"};